function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.953 52.831l-.02.013V.874l39.842 25.871L116.616.873v51.971l-.028-.019v22.042h.003l-39.816 36.006-39.816-36.006h-.006V52.831z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.953 52.831l-.02.013V.874l39.842 25.871L116.616.873v51.971l-.028-.019v22.042h.003l-39.816 36.006-39.816-36.006h-.006V52.831z",
  fill: "#CD3301"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.953 52.831h2v-3.683l-3.089 2.006 1.09 1.677zm-.02.013h-2v3.683l3.09-2.006-1.09-1.677zm0-51.97l1.09-1.678-3.09-2.006V.873h2zm39.842 25.871l-1.09 1.677 1.09.708 1.09-.707-1.09-1.678zM116.616.873h2V-2.81l-3.089 2.006 1.089 1.677zm0 51.971l-1.089 1.677 3.089 2.006v-3.683h-2zm-.028-.019l1.089-1.677-3.089-2.006v3.683h2zm0 22.042h-2v2h2v-2zm.003 0l1.341 1.483 3.852-3.483h-5.193v2zm-39.816 36.006l-1.342 1.484 1.342 1.213 1.341-1.213-1.341-1.484zM36.959 74.867l1.342-1.483-.571-.517h-.77v2zm-.006 0h-2v2h2v-2zm-1.089-23.713l-.02.013 2.179 3.354.02-.012-2.179-3.355zm3.07 1.69V.874h-4v51.97h4zm-3.09-50.293l39.842 25.871 2.178-3.354L38.023-.804l-2.179 3.355zm79.683-3.355L75.686 25.068l2.178 3.354 39.842-25.871-2.179-3.355zm3.089 53.648V.874h-4v51.97h4zm-3.117 1.659l.028.018 2.178-3.354-.028-.019-2.178 3.355zm3.089 20.364V52.825h-4v22.042h4zm-1.997-2h-.003v4h.003v-4zm-38.474 39.49l39.815-36.007-2.683-2.966-39.816 36.006 2.683 2.967zM35.617 76.35l39.815 36.007 2.683-2.967-39.815-36.006-2.683 2.966zm1.335.517h.006v-4h-.006v4zm-2-24.036v22.036h4V52.831h-4z",
  fill: "#7E0404",
  mask: "url(#a)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.516.73L76.7 26.855l.004.003H76.7V110.873l40-36.006h-.183V26.86h-.001V.729z",
  fill: "#7E0404"
});

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.326 4.5L76.5 29.32l.004.003H76.5v79.814l38-34.206h-.174V4.5z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.326 4.5L76.5 29.32l.004.003H76.5v79.814l38-34.206h-.174V4.5z",
  fill: "#7E0404"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M76.5 29.32l-1.097-1.672-2.562 1.681 2.57 1.669L76.5 29.32zM114.326 4.5h2V.796l-3.098 2.032 1.098 1.672zM76.504 29.323v2h6.755l-5.666-3.678-1.089 1.678zm-.004 0v-2h-2v2h2zm0 45.608h-2 2zm0 34.206h-2v4.491l3.338-3.005-1.338-1.486zm38-34.206l1.338 1.486 3.874-3.487H114.5v2zm-.174 0h-2v2h2.001l-.001-2zm0-45.608h2v-2h-2v2zm0 0h-2v2h2v-2zm-36.729 1.67l37.826-24.82-2.195-3.345-37.825 24.82 2.194 3.344zm-.004-3.348l-.004-.002-2.178 3.355.004.002 2.178-3.355zM76.5 31.323h.004v-4H76.5v4zm2 43.608V29.323h-4V74.93h4zm0 34.206V74.931h-4v34.206h4zm34.662-35.693l-38 34.206 2.676 2.973 38-34.206-2.676-2.973zm1.165 3.487h.173v-4h-.174l.001 4zm-2.001-47.608V74.93h4V29.323h-4zm2 2v-4 4zm-2-26.823v24.823h4V4.5h-4z",
  fill: "#CD3301",
  mask: "url(#b)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M70.365 23.89l.549-2.836 13.545-4.393-2.105 4.942 5.033 12.446-4.21 8.42 10.434-12.446L152 13l-29.378 33.862 3.661-9.152-11.257 3.203-11.623 14.643v-3.203l-10.89 4.027 1.738-4.667-9.7 13.453 6.772 11.165-5.674 6.773-4.21-9.335 3.111 11.074-7.413 8.51-7.321-8.876 3.569-10.708-5.857 9.335-5.034-6.773 6.681-10.799-8.328-13.545.366 4.76-10.525-4.394-2.38 3.844-8.785-15.467-10.708-3.111 5.217 12.72L2 13.184l59.396 17.023 6.132 6.497 1.098-7.321h-4.393l1.647-3.386 4.485-2.105z",
  fill: "#fff",
  stroke: "#7E0404"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M77 96l3.592 11.056h11.625l-9.405 6.833 3.593 11.055L77 118.111l-9.405 6.833 3.593-11.055-9.405-6.833h11.625L77 96z",
  fill: "#E7B811"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M77 96l3.592 11.056h11.625l-9.405 6.833 3.593 11.055L77 118.111l-9.405 6.833 3.593-11.055-9.405-6.833h11.625L77 96z",
  fill: "#E7B811"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M77 96l3.592 11.056h11.625l-9.405 6.833 3.593 11.055L77 118.111l-9.405 6.833 3.593-11.055-9.405-6.833h11.625L77 96z",
  stroke: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M77 96l3.592 11.056h11.625l-9.405 6.833 3.593 11.055L77 118.111l-9.405 6.833 3.593-11.055-9.405-6.833h11.625L77 96z",
  stroke: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M51.783 85l2.597 8.403h8.403l-6.798 5.194L58.58 107l-6.798-5.193L44.985 107l2.596-8.403-6.798-5.194h8.403L51.783 85z",
  fill: "#E7B811"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M51.783 85l2.597 8.403h8.403l-6.798 5.194L58.58 107l-6.798-5.193L44.985 107l2.596-8.403-6.798-5.194h8.403L51.783 85z",
  fill: "#E7B811"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M51.783 85l2.597 8.403h8.403l-6.798 5.194L58.58 107l-6.798-5.193L44.985 107l2.596-8.403-6.798-5.194h8.403L51.783 85z",
  stroke: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M51.783 85l2.597 8.403h8.403l-6.798 5.194L58.58 107l-6.798-5.193L44.985 107l2.596-8.403-6.798-5.194h8.403L51.783 85z",
  stroke: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M101.783 85l2.597 8.403h8.403l-6.798 5.194 2.596 8.403-6.798-5.193L94.985 107l2.597-8.403-6.799-5.194h8.403L101.783 85z",
  fill: "#E7B811"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M101.783 85l2.597 8.403h8.403l-6.798 5.194 2.596 8.403-6.798-5.193L94.985 107l2.597-8.403-6.799-5.194h8.403L101.783 85z",
  fill: "#E7B811"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M101.783 85l2.597 8.403h8.403l-6.798 5.194 2.596 8.403-6.798-5.193L94.985 107l2.597-8.403-6.799-5.194h8.403L101.783 85z",
  stroke: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M101.783 85l2.597 8.403h8.403l-6.798 5.194 2.596 8.403-6.798-5.193L94.985 107l2.597-8.403-6.799-5.194h8.403L101.783 85z",
  stroke: "#fff"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 154 127",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2fc97f26.svg";
export { ForwardRef as ReactComponent };